import { h } from "preact";

const CheckmarkIcon = ({ color = "var(--straumur__color-primary)" }: { color?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
    <path d="M2 7L6 11L14 2" stroke={color} stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export default CheckmarkIcon;
